export default __webpack_public_path__ + "static/media/subasta_bg.f85eab30.png";